import React from 'react'
import { Button, Modal, Select, TextArea } from '../../../components'
import './rejeitarplanomodal.scss'

const RejeitarPlanoModal = ({
  open,
  close,
  nls,
  nomePlano,
  motivos,
  motivoSelecionado,
  comentario,
  loadingMotivos,
  loadingSubmit,
  onChangeMotivo,
  onChangeComentario,
  onConfirmar
}) => {
  return (
    <Modal
  cy='pdca-plan-reject'
  open={open}
  close={close}
  title={nls.rejeitarPlano}
  size="medium"
>
      <div className="pdca-rejeitarplano-modal">
        <div className="pdca-rejeitarplano-modal__nome">{nomePlano}</div>

        <div className="pdca-rejeitarplano-modal__campo">
          <Select
            name="motivoRejeicao"
            label={nls.motivo}
            options={motivos}
            selected={motivoSelecionado || {}}
            action={onChangeMotivo}
            selectedItem={false}
            optionLabel="label"
            optionValue="value"
            disabled={loadingMotivos || loadingSubmit || motivos.length === 0}
          />
        </div>

        <div className="pdca-rejeitarplano-modal__campo">
          <div className="pdca-rejeitarplano-modal__label">{nls.comentario}</div>

          <TextArea
            name="comentario"
            value={comentario}
            action={onChangeComentario}
            disabled={loadingSubmit}
          />
        </div>

        <div className="pdca-rejeitarplano-modal__acoes">
          <Button
  data-cy='pdca-plan-reject-confirm'
  data-cy-effect='write'
  color="primary"
  onClick={onConfirmar}
  disabled={loadingMotivos || loadingSubmit}
>
            {nls.confirmar}
          </Button>

          <Button
  data-cy='pdca-plan-reject-cancel'
  data-cy-effect='read'
  onClick={close}
  disabled={loadingSubmit}
>
            {nls.cancelar}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default RejeitarPlanoModal